import React from 'react';

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div style={{
      backgroundColor: '#FEF2F2',
      border: '1px solid #FCA5A5',
      borderRadius: '12px',
      padding: '12px 16px',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      animation: 'fadeIn 0.3s ease-out',
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{
        backgroundColor: '#EF4444',
        color: 'white',
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: 'bold',
        flexShrink: 0
      }}>!</div>
      <div style={{
        color: '#991B1B',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '1.4'
      }}>
        {message}
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ErrorMessage;
